/**
 * Accumulation/Distribution Line (ADL)
 *
 * Volume-based indicator measuring cumulative money flow.
 * CLV = ((Close − Low) − (High − Close)) / (High − Low)
 * ADL = cumulative sum of CLV × Volume.
 *
 * Category: Volume | Pane: Separate
 */
import { IndicatorDefinition, PlotData } from "../types/indicator.types";
import { CandleData } from "../../types/chart.types";

export const adlIndicator: IndicatorDefinition = {
  id: "adl",
  name: "Accumulation/Distribution",
  shortName: "A/D",
  category: "volume",
  pane: "separate",
  params: [
    { key: "color", label: "Color", type: "color", default: "#2196F3" },
  ],
  plots: [
    { key: "adl", label: "A/D", color: "#2196F3", style: "line", lineWidth: 2, priceScaleId: "adl" },
  ],
  calculate: (candles: CandleData[], params: Record<string, any>): PlotData[] => {
    const data: { time: number; value: number }[] = [];
    let adl = 0;

    for (let i = 0; i < candles.length; i++) {
      const hl = candles[i].high - candles[i].low;
      const clv = hl === 0 ? 0 : ((candles[i].close - candles[i].low) - (candles[i].high - candles[i].close)) / hl;
      adl += clv * (candles[i].volume || 0);
      data.push({ time: candles[i].time, value: adl });
    }

    return [{ key: "adl", data }];
  },
};
